import MypageContainer from "../../components/mypage/MyPageContainer";
import MyPageContent from "../../components/mypage/MyPageContent";
import MyPageHeader from "../../components/mypage/MyPageHeader";
import MypageMenu from "../../components/mypage/MyPageMenu";

import styles from './Mypage.module.css'; // CSS Modules 파일 import
import {Link} from 'react-router-dom';
import React, {useContext,useState, useEffect} from 'react';
import axios from 'axios';
import {formatDate} from '../../middlewares/formatDate';
import {formatPhone} from '../../middlewares/formatDate';
import { MyPageContext } from "../../components/mypage/MyPageContext";


const Mypage = () => {
    const [projectingData, setProjectingData] = useState(null);
    const [projectedData, setProjectedData] = useState();
    const { data } = useContext(MyPageContext);
    if(!data.user){
        window.location.reload();
    }
    useEffect(() => {
        const fetchData = async () => {
            try {
                const userEmail=(JSON.parse(data.user).userEmail)
                const response = await axios.get(
                    `${process.env.REACT_APP_SERVER_URL}/users/${userEmail}`
                );
    
                if (response.status === 200) {
                    data.userData=response.data.data[0];
                } else {
                    throw new Error('서버 응답 오류');
                }
            } catch (error) {
                console.error('에러 발생:', error.message);
            }
        };
        if(data){
            fetchData(); // fetchData 함수를 호출
        }
    }, [data]);
    useEffect(() => {
        const fetchProjectingData = async () => {
            try {
                const formData = new FormData();
                formData.append('projectClient', data.userData.userEmail);
                formData.append('projectStatus', '진행중');
                const response = await axios.post(
                    `${process.env.REACT_APP_SERVER_URL}/mypage/project`,
                    formData
                );
                if (response.status === 200) {
                    setProjectingData(response.data.result);
                } else {
                    throw new Error('서버 응답 오류');
                }
            } catch (error) {
                console.log(error);
                alert(error);
            }
        };
        if(data.userData!=null){
            fetchProjectingData();
        }
    }, [data]);
    
    useEffect(() => {
        const fetchProjectingData = async () => {
             //알람 업데이트
             try {
                const response = await axios.get(
                    `${process.env.REACT_APP_SERVER_URL}/mypage/alarm/${data.userData.userEmail}`
                );
                if (response.status === 200) {
                    data.alarmData=response.data
                } else {
                    throw new Error('서버 응답 오류');
                }
            } catch (error) {
                alert(error);
            }
        };
        if(data.userData!=null){
            fetchProjectingData();
        }
    }, [data]);


    useEffect(() => {
        const fetchProjectedData = async () => {
            try {
                const formData = new FormData();
                formData.append('projectClient', data.userData.userEmail);
                formData.append('projectStatus', '작업완료');
                const response = await axios.post(
                    `${process.env.REACT_APP_SERVER_URL}/mypage/project`,
                    formData
                );
                if (response.status === 200) {
                    setProjectedData(response.data.result[0]);
                } else {
                    throw new Error('서버 응답 오류');
                }
            } catch (error) {
                console.log(error);
                alert(error);
            }
        };
        if(data.userData!=null){
        fetchProjectedData();
        }
    }, [data]);

    

    return (
        <div className="mypageContainer">
            <MypageMenu  />
            <MypageContainer>
                <MyPageHeader title="대시보드" />
                <MyPageContent>
                    {/* 여기에 컨텐츠 (내용)을 디자인 해주세요*/}
                    <ul className={styles.MenuContainer01}>
                        {(data.alarmData!=null)?
                        <li>
                            <h2>알림</h2><ul className={styles.notification}>
                                    <li>
                                        <label>새알림</label>
                                        <div>
                                            <p className={styles.number}>{data.alarmData.newAlarm}</p>
                                            개
                                        </div>
                                    </li>
                                    <li>
                                        <label>총 알림 수</label>
                                        <div>
                                            <p className={styles.number}>{data.alarmData.sumAlarm}</p>
                                            개
                                        </div>
                                    </li>
                                </ul>
                        </li>
                        :
                        null
                        }
                        {(data.userData!=null)?
                        <>
                        <li>
                            <h2>계정 정보</h2>
                            <ul className={styles.telephoneBox}>
                                <li>
                                    <p>휴대폰</p>
                                    <div className={styles.txt}>
                                        <div className={styles.icon}>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none">
                                                <path
                                                    d="M19.4396 12.9999C19.2196 12.9999 18.9896 12.9299 18.7696 12.8799C18.3241 12.7817 17.8863 12.6514 17.4596 12.4899C16.9957 12.3211 16.4858 12.3299 16.0279 12.5145C15.5701 12.6991 15.1967 13.0465 14.9796 13.4899L14.7596 13.9399C13.7856 13.398 12.8906 12.7251 12.0996 11.9399C11.3144 11.1489 10.6414 10.2539 10.0996 9.27987L10.5196 8.99987C10.963 8.78278 11.3104 8.4094 11.495 7.95156C11.6796 7.49372 11.6884 6.98378 11.5196 6.51987C11.3608 6.09229 11.2305 5.65467 11.1296 5.20987C11.0796 4.98987 11.0396 4.75987 11.0096 4.52987C10.8882 3.82549 10.5192 3.18761 9.96923 2.73111C9.41923 2.2746 8.72431 2.02948 8.00961 2.03987H5.00961C4.57864 2.03582 4.15186 2.12468 3.75832 2.3004C3.36478 2.47612 3.01372 2.73456 2.72904 3.05815C2.44436 3.38174 2.23275 3.76286 2.1086 4.17558C1.98445 4.5883 1.95069 5.02293 2.00961 5.44987C2.54235 9.63925 4.45564 13.5317 7.44726 16.5125C10.4389 19.4933 14.3383 21.3924 18.5296 21.9099H18.9096C19.647 21.9109 20.359 21.6404 20.9096 21.1499C21.226 20.8669 21.4787 20.52 21.6511 20.1322C21.8235 19.7443 21.9116 19.3243 21.9096 18.8999V15.8999C21.8974 15.2053 21.6444 14.5364 21.194 14.0075C20.7435 13.4786 20.1234 13.1225 19.4396 12.9999ZM19.9396 18.9999C19.9394 19.1419 19.909 19.2822 19.8504 19.4115C19.7918 19.5408 19.7063 19.6562 19.5996 19.7499C19.4879 19.8463 19.3572 19.9184 19.216 19.9615C19.0748 20.0045 18.9262 20.0176 18.7796 19.9999C15.0345 19.5197 11.5558 17.8064 8.89233 15.1302C6.22881 12.454 4.53202 8.96721 4.06961 5.21987C4.0537 5.07339 4.06765 4.9252 4.11061 4.78426C4.15358 4.64332 4.22468 4.51256 4.31961 4.39987C4.41332 4.2932 4.52867 4.20771 4.65799 4.14909C4.78731 4.09046 4.92763 4.06005 5.06961 4.05987H8.06961C8.30216 4.05469 8.52924 4.13075 8.71176 4.27494C8.89428 4.41913 9.02082 4.62244 9.06961 4.84987C9.10961 5.1232 9.15961 5.3932 9.21961 5.65987C9.33513 6.18701 9.48887 6.70505 9.67961 7.20987L8.27961 7.85987C8.15991 7.91479 8.05223 7.99281 7.96277 8.08946C7.87331 8.18611 7.80381 8.29948 7.75828 8.42306C7.71275 8.54664 7.69208 8.678 7.69746 8.80959C7.70284 8.94118 7.73415 9.07041 7.78961 9.18987C9.22881 12.2726 11.7069 14.7507 14.7896 16.1899C15.0331 16.2899 15.3062 16.2899 15.5496 16.1899C15.6743 16.1453 15.7889 16.0763 15.8868 15.9871C15.9846 15.8978 16.0638 15.79 16.1196 15.6699L16.7396 14.2699C17.2566 14.4547 17.7842 14.6084 18.3196 14.7299C18.5863 14.7899 18.8563 14.8399 19.1296 14.8799C19.357 14.9287 19.5604 15.0552 19.7045 15.2377C19.8487 15.4202 19.9248 15.6473 19.9196 15.8799L19.9396 18.9999Z"
                                                    fill="white"/>
                                            </svg>
                                        </div>
                                        {formatPhone(data.userData.userPhone)}
                                    </div>
                                </li>
                                <li>
                                    <p>이메일</p>
                                    <div className={styles.txt}>
                                        <div className={styles.icon}>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none">
                                                <path
                                                    d="M19 4H5C4.20435 4 3.44129 4.31607 2.87868 4.87868C2.31607 5.44129 2 6.20435 2 7V17C2 17.7956 2.31607 18.5587 2.87868 19.1213C3.44129 19.6839 4.20435 20 5 20H19C19.7956 20 20.5587 19.6839 21.1213 19.1213C21.6839 18.5587 22 17.7956 22 17V7C22 6.20435 21.6839 5.44129 21.1213 4.87868C20.5587 4.31607 19.7956 4 19 4ZM18.59 6L12.71 11.88C12.617 11.9737 12.5064 12.0481 12.3846 12.0989C12.2627 12.1497 12.132 12.1758 12 12.1758C11.868 12.1758 11.7373 12.1497 11.6154 12.0989C11.4936 12.0481 11.383 11.9737 11.29 11.88L5.41 6H18.59ZM20 17C20 17.2652 19.8946 17.5196 19.7071 17.7071C19.5196 17.8946 19.2652 18 19 18H5C4.73478 18 4.48043 17.8946 4.29289 17.7071C4.10536 17.5196 4 17.2652 4 17V7.41L9.88 13.29C10.4425 13.8518 11.205 14.1674 12 14.1674C12.795 14.1674 13.5575 13.8518 14.12 13.29L20 7.41V17Z"
                                                    fill="white"/>
                                            </svg>
                                        </div>
                                        {data.userData.userEmail}
                                    </div>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <h2>EVENT/NEWS 정보</h2>
                            <div className={styles.newsBox}>
                                <div className={styles.imgBox}>
                                    <a href="#"></a>
                                </div>
                                <div className={styles.smallImgBox}>
                                    <a href="#"></a>
                                </div>
                            </div>
                        </li>
                        </>
                        :
                        null
                        }
                    </ul>
                    <ul className={styles.MenuContainer02}>
                        <li>
                            <h2>진행중인 작업</h2>
                            {
                                projectingData && (
                                    // projectingData가 존재하는지 확인
                                    <div className={styles.workBox}>
                                        <div
                                            className={styles.imgBox}
                                            style={{
                                                backgroundImage: `url("${process.env.REACT_APP_SERVER_URL}/uploads/project/${projectingData.projectFile1}")`
                                            }}>
                                            <Link to={`/project/view/${projectingData.id}`}></Link>
                                        </div>

                                        <div className={styles.contentBox}>
                                            <p className={styles.category}>
                                                <Link to={`/project/view/${projectingData.id}`}>
                                                    {projectingData.projectName}
                                                </Link>
                                            </p>
                                            <Link to={`/project/view/${projectingData.id}`}>
                                                <div className={styles.titleBox}>
                                                    <p className={styles.title}>{projectingData.projectIntro}</p>
                                                    <p className={styles.more}>더보기 +</p>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                )
                            }
                        </li>
                        <li>
                            <h2>
                                <p>종료된 작업</p>
                                <p className={styles.goBtn}>
                                    <Link to={{ pathname: '/mypage/myproject',search: `?searchcontent=작업완료&searchoption=projectStatus`}}>전체보기 +</Link>
                                </p>
                            </h2>
                            <ul className={styles.workList}>
                                <li className={styles.title}>
                                    <div className={styles.content}>내용</div>
                                    <div className={styles.name}>작업자</div>
                                    <div className={styles.date}>요청일자</div>
                                    <div className={styles.date}>완료일자</div>
                                </li>
                                {
                                    (projectedData)
                                        ? projectedData.map((project) => (
                                            <li className={styles.title} key={project.id}>
                                                {/* <Link to={`/project/view/${project.id}`}> */}
                                                <div className={styles.content}>{project.projectIntro}</div>
                                                <div className={styles.name}>{project.projectWorker}</div>
                                                <div className={styles.date}>{formatDate(project.projectStart)}</div>
                                                <div className={styles.date}>{formatDate(project.projectEnd)}</div>
                                                {/* </Link> */}
                                            </li>
                                        ))
                                        : null
                                }
                            </ul>
                        </li>
                    </ul>
                </MyPageContent>
            </MypageContainer>
        </div>
    );
}

export default Mypage;